export const VARIAVEIS = [
  { key: "{nome_cliente}", desc: "Nome do tutor" },
  { key: "{nome_pet}", desc: "Nome do pet" },
  { key: "{nome_pets}", desc: "Nomes dos pets selecionados" },
  { key: "{artigo_pet}", desc: '"do" ou "da" (sexo do pet)' },
  { key: "{dias_ausente}", desc: "Dias sem visita" },
  { key: "{nome_loja}", desc: "Nome da loja" },
  { key: "{telefone_loja}", desc: "Telefone da loja" },
];

export const SORTABLE_COLUMN_KEYS = {
  Cliente: "customerName",
  Pet: "petName",
  Ausência: "absenceDays",
  "Último agend.": "lastAppointmentAt",
  "Próximo agend.": "nextAppointmentAt",
  Contato: "latestContactAt",
};

export const CRM_PET_RULE_TABS = [
  { value: "ALL", label: "Todos" },
  { value: "ABSENT", label: "Ausentes" },
  { value: "POTENTIAL_SUBSCRIBER", label: "Possíveis assinantes" },
  { value: "NO_PRODUCT", label: "Produtos" },
  { value: "NO_ADDITIONAL", label: "Serviços/Adicionais" },
];

export const CRM_PET_ANALYSIS_DAY_OPTIONS = [7, 15, 30, 45, 60, 90];

export const CRM_PET_PRODUCT_CATEGORIES = [
  { code: "RACAO", label: "Ração", order: 1 },
  { code: "TAPETE", label: "Tapete", order: 2 },
  { code: "PETISCOS", label: "Petiscos", order: 3 },
  { code: "ANTI_PULGAS", label: "Anti pulgas", order: 4 },
];

export const CRM_PET_SERVICE_CATEGORIES = [
  { code: "TOSA", label: "Tosa", order: 1 },
  { code: "ESCOVACAO", label: "Escovação de dentes", order: 2 },
  { code: "CORTE_UNHAS", label: "Corte de unhas", order: 3 },
  { code: "HIDRATACAO", label: "Hidratação", order: 4 },
];

export const CRM_PET_SUBSCRIPTION_OPTIONS = [
  { value: "ALL", label: "Todos os pets" },
  { value: "ACTIVE", label: "Assinantes" },
  { value: "FORMER", label: "Ex-assinantes" },
  { value: "NEVER", label: "Nunca assinaram" },
];
